import React from 'react'
import {connect} from 'react-redux'
import {is, fromJS} from 'immutable'

import {
  SCROLL_POS_CONCERNS,
  MESSAGE_TYPES,
  MESSAGE_APPROVAL_STATUSES
} from '../config/constants'

import getPreviousMessages from '../data/getters/previous_messages'
import removePreviousMessages from '../data/actions/remove_previous_messages'
import {watchNewMessages, unwatchNewMessages} from '../data/watchers/new_messages'
import isUserModerator from '../data/helpers/is_user_moderator'
import isMessageOwnedByUser from '../data/helpers/is_message_owned_by_user'

import ConversationScroller from './scroller'
import MessagesList from './messages_list'
import InlineNotification from './inline_notification'

const MESSAGE_UPDATE_CONCERNS = {
  HISTORY: -1,
  INITIAL: 0,
  NEW: 1
}

class ConversationContent extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.onMessageItemHeightChange = this.onMessageItemHeightChange.bind(this)
    this.onScrollConcernChange = this.onScrollConcernChange.bind(this)
    this.scrollToBottom = this.scrollToBottom.bind(this)
  }

  componentWillMount () {
    if (!this.props.isDisabled) {
      this.props.onContentLoaded(
        this.props.conversationContainerId,
        this.props.shouldLoadPreviousMessages,
        this.props.historyBatchLimit
      )
    }

    if (this.props.messages && this.props.messages.size > 0) {
      this.setMessageUpdateSideEffects(this.props.messages)
    }
  }

  componentWillReceiveProps (nextProps) {
    if (!is(this.props.messages, nextProps.messages)) {
      this.setMessageUpdateSideEffects(nextProps.messages)
    }

    if (!nextProps.isDisabled && nextProps.conversationContainerId !== this.props.conversationContainerId) {
      this.props.onContentUpdated(
        nextProps.conversationContainerId,
        this.props.conversationContainerId,
        this.props.shouldLoadPreviousMessages,
        this.props.historyBatchLimit
      )
    }

    if (this.props.isDisabled && !nextProps.isDisabled) {
      this.props.onContentLoaded(
        nextProps.conversationContainerId,
        nextProps.shouldLoadPreviousMessages,
        nextProps.historyBatchLimit
      )
    }
    else if (!this.props.isDisabled && nextProps.isDisabled) {
      this.props.onContentUnloaded(this.props.conversationContainerId)
    }
  }

  componentWillUnmount () {
    this.props.onContentUnloaded(this.props.conversationContainerId)
  }

  shouldLoadHistory (scrollConcern) {
    return (
      this.props.shouldLoadHistoryMessages
      && scrollConcern === SCROLL_POS_CONCERNS.TOP
    )
  }

  shouldPutNewMessageInformer (lastMessageTime) {
    return (
      this.state.scrollConcern !== SCROLL_POS_CONCERNS.BOTTOM
      && this.state.lastMessageTime
      && lastMessageTime > this.state.lastMessageTime
    )
  }

  setMessageUpdateSideEffects (nextMessages) {
    const firstMessageTime = nextMessages.getIn([0, 'time'])
    let lastMessageTime = nextMessages.getIn([nextMessages.size - 1, 'time'])
    lastMessageTime = this.amendLastMessageTimeForModeratedGroups(lastMessageTime, nextMessages)

    let newMessageInformer = false
    let updatingScrollConcern = this.getUpdatingScrollConcernForMessageConcern(firstMessageTime, lastMessageTime)

    if (this.shouldPutNewMessageInformer(lastMessageTime)) {
      newMessageInformer = true
    }

    this.setState({firstMessageTime, lastMessageTime, updatingScrollConcern})
    this.setNewMessageInformer(newMessageInformer)
  }

  getUpdatingScrollConcernForMessageConcern (firstMessageTime, lastMessageTime) {
    const {HISTORY, INITIAL, NEW} = MESSAGE_UPDATE_CONCERNS
    const messageUpdateConcern = this.getMessageUpdateConcern(firstMessageTime, lastMessageTime)

    if (messageUpdateConcern === HISTORY) return SCROLL_POS_CONCERNS.HISTORY
    if (messageUpdateConcern === INITIAL) return SCROLL_POS_CONCERNS.BOTTOM
    if (messageUpdateConcern === NEW) return SCROLL_POS_CONCERNS.BOTTOM
  }

  getMessageUpdateConcern (firstMessageTime, lastMessageTime) {
    const {HISTORY, INITIAL, NEW} = MESSAGE_UPDATE_CONCERNS

    if (!this.state.firstMessageTime && firstMessageTime) return INITIAL
    else if (this.state.firstMessageTime && this.state.firstMessageTime > firstMessageTime) return HISTORY
    else if (this.state.lastMessageTime && this.state.lastMessageTime < lastMessageTime) return NEW
  }

  amendLastMessageTimeForModeratedGroups (lastMessageTime, nextMessages) {
    if (this.props.messageType !== MESSAGE_TYPES.MODERATED_GROUP) return lastMessageTime
    if (this.props.currentUser && isUserModerator(this.props.currentUser.get('role'))) return lastMessageTime

    const lastMessage = nextMessages.last()
    if (this.props.currentUser && isMessageOwnedByUser(lastMessage.get('from'), this.props.currentUser.get('uid'))) {
      return lastMessageTime
    }

    const lastApprovedMessage = nextMessages
      .findLast((m) => m.get('approvalStatus') === MESSAGE_APPROVAL_STATUSES.APPROVED)

    if (lastApprovedMessage) lastMessageTime = lastApprovedMessage.get('time')

    return lastMessageTime
  }

  setScrollConcern (scrollConcern) {
    this.setState({scrollConcern})

    if (scrollConcern === SCROLL_POS_CONCERNS.BOTTOM) {
      this.setNewMessageInformer(false)
    }

    if (scrollConcern === this.state.updatingScrollConcern || this.state.updatingScrollConcern === SCROLL_POS_CONCERNS.HISTORY) {
      this.setState({updatingScrollConcern: null})
    }
  }

  setNewMessageInformer (newMessageInformer) {
    if (newMessageInformer !== this.state.newMessageInformer) {
      this.setState({newMessageInformer})
    }
  }

  getPreviousMessages () {
    this.props.getPreviousMessages(
      this.props.conversationContainerId,
      this.props.historyBatchLimit,
      this.state.firstMessageTime
    )
  }

  scrollToBottom (e) {
    if (e && e.preventDefault) e.preventDefault()

    if (this.state.scrollConcern !== SCROLL_POS_CONCERNS.BOTTOM) {
      this.setState({updatingScrollConcern: SCROLL_POS_CONCERNS.FORCE_BOTTOM})
    }
  }

  onMessageItemHeightChange (/* difference */) {
    // TODO: implement scroll adjust behavior here
  }

  onScrollConcernChange (scrollConcern) {
    if (this.shouldLoadHistory(scrollConcern)) this.getPreviousMessages()

    this.setScrollConcern(scrollConcern)
  }

  renderInformer () {
    if (this.state.newMessageInformer) {
      return (
        <InlineNotification onClick={this.scrollToBottom}>
          New message <i className='rc-icon-arrow-down' style={{marginLeft: 5}}/>
        </InlineNotification>
      )
    }
  }

  renderConversationContent () {
    return (
      <ConversationScroller
        updatingScrollConcern={this.state.updatingScrollConcern}
        onScrollConcernChange={this.onScrollConcernChange}>
        <MessagesList
          key='messagesList'
          contentMessage={this.props.contentMessage}
          messages={this.props.messages}
          messageType={this.props.messageType}
          containerId={this.props.conversationContainerId}
          maxBubbleWidth={this.props.maxBubbleWidth}
          onMessageItemHeightChange={this.onMessageItemHeightChange}
          isRichMessageContentEnabled={this.props.isRichMessageContentEnabled}/>
      </ConversationScroller>
    )
  }

  render () {
    return (
      <div
        className='conversation-content'
        style={{padding: 0, height: this.props.height, backgroundColor: this.props.backgroundColor}}>
        {this.renderInformer()}
        {this.renderConversationContent()}
      </div>
    )
  }
}

ConversationContent.defaultProps = {
  shouldLoadPreviousMessages: true,
  shouldLoadHistoryMessages: false,
  historyBatchLimit: null
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.get('currentUser'),
    messages: state.getIn(['messages', ownProps.conversationContainerId], fromJS([])),
    backgroundColor: state.getIn(['chatSettings', 'colors', 'conversation', 'background'])
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onContentLoaded: (containerId, shouldLoadPreviousMessages, limit) => {
      if (shouldLoadPreviousMessages) {
        getPreviousMessages(containerId, limit)
        .then(watchNewMessages.bind(null, containerId, ownProps.notificationOptions))
      }
      else {
        watchNewMessages(containerId, ownProps.notificationOptions)
      }
    },
    onContentUpdated: (nextContainerId, containerId, shouldLoadPreviousMessages, limit) => {
      unwatchNewMessages(containerId)
      dispatch(removePreviousMessages(containerId))

      if (shouldLoadPreviousMessages) {
        getPreviousMessages(nextContainerId, limit)
        .then(watchNewMessages.bind(null, nextContainerId, ownProps.notificationOptions))
      }
      else {
        watchNewMessages(nextContainerId, ownProps.notificationOptions)
      }
    },
    onContentUnloaded: (containerId) => {
      unwatchNewMessages(containerId)
      dispatch(removePreviousMessages(containerId))
    },
    getPreviousMessages: getPreviousMessages
  }
}

const ConversationContentContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ConversationContent)

export default ConversationContentContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/conversation/content.js
 **/